import { render } from "./Branding.vue?vue&type=template&id=2c614a4a&scoped=true"
import script from "./Branding.vue?vue&type=script&lang=js"
export * from "./Branding.vue?vue&type=script&lang=js"

import "./Branding.vue?vue&type=style&index=0&id=2c614a4a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c614a4a"]])

export default __exports__